import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Pagination, Table, Icon, Spin } from 'antd';
import TableSortedHeader from '../../../components/table_sorted_header/TableSortedHeader';

const antIcon = <Icon type='loading' style={{ fontSize: 24 }} spin />;

class TableComponent extends Component {
  handleRouteToFinalReview = (domain) => {
    if (
      this.props.tableFor === 'usageUrl' ||
      this.props.tableFor === 'clickhouseUsageUrl'
    ) {
      return;
    } else if (this.props.redirectPermission) {
      window.open(`/final_review?domainName=${domain}`).focus();
    } else {
      window.open('/403');
    }
  };

  handleChangePage = (page, pageSize) => {
    this.props.onChangePagination(this.props.tableFor, page, pageSize);
  };

  onShowSizeChange = (page, pageSize) => {
    this.props.onChangePagination(this.props.tableFor, page, pageSize);
  };

  showTotal = (total) => {
    return (
      <>
        {this.props.tableData.usageUrlCount > -1 ? (
          <span>
            Total{' '}
            <b>
              {this.props.tableData.usageUrlCount &&
                this.props.tableData.usageUrlCount}
            </b>{' '}
            items
          </span>
        ) : (
          <>
            <span style={{ marginRight: '1rem' }}>Total</span>
            <Spin indicator={antIcon} />
          </>
        )}
      </>
    );
  };

  prepareTableColumns = () => {
    // let filteredColumns = this.props.tableColumns.filter((tc) =>
    //   _.includes(this.props.selectedFiltersFields, tc.fieldKey)
    // );

    return this.props.tableColumns.map((column) => {
      let sortingOptions = {};
      if (this.props.sortingOptions.hasOwnProperty(column.fieldKey)) {
        sortingOptions = this.props.sortingOptions[column.fieldKey];
      }

      if (column.customSorted) {
        column.title = () => (
          <TableSortedHeader
            headerTitle={column.originTitle}
            sortOptions={sortingOptions}
          />
        );

        column.onHeaderCell = (column) => {
          return {
            onClick: () => {
              this.props.handleChangeColumnSort(this.props.tableFor, column);
            }
          };
        };
      } else {
        column.title = column.originTitle;
      }

      // column.sortOrder = sortOption.type
      return column;
    });
  };

  render() {
    return (
      <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24'>
        <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24 m-b-25'>
          <Table
            rowKey='id'
            style={{ cursor: 'pointer' }}
            filtered={true}
            bordered
            locale={{
              emptyText: this.props.noDataMsg
                ? this.props.noDataMsg
                : 'No data for the selected filters'
            }}
            columns={this.prepareTableColumns()}
            pagination={false}
            dataSource={this.props.tableData.content}
            scroll={{ x: false }}
            onRow={(record, rowIndex) => ({
              onClick: () => {
                this.handleRouteToFinalReview(record.domain);
              }
            })}
            className='temp-table-style'
            rowSelection={this.props.rowSelection && this.props.rowSelection}
          />
        </div>
        {this.props.tableData.count > 0 && (
          <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24'>
            <Pagination
              pageSizeOptions={['25', '50', '100', '200', '1000']}
              showQuickJumper
              showTotal={this.showTotal}
              showSizeChanger
              onShowSizeChange={this.onShowSizeChange}
              current={this.props.paginationOptions.pageNumber}
              pageSize={this.props.paginationOptions.pageSize}
              className='mt-4 mb-4 mr-3'
              total={
                this.props.tableData.usageUrlCount
                  ? this.props.tableData.usageUrlCount
                  : this.props.tableData.usageUrlCountStatic
              }
              onChange={this.handleChangePage}
            />
          </div>
        )}
      </div>
    );
  }
}

TableComponent.propTypes = {
  tableFor: PropTypes.string.isRequired,
  tableData: PropTypes.object.isRequired,
  tableColumns: PropTypes.array.isRequired,
  paginationOptions: PropTypes.object.isRequired,
  selectedFiltersFields: PropTypes.array.isRequired,
  sortingOptions: PropTypes.object.isRequired,
  onChangePagination: PropTypes.func,
  handleChangeColumnSort: PropTypes.func
};

export default TableComponent;
